import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminService } from '../../Services/Admin.service';
import Sidebar from '../../Components/Sidebar';
  
import DashboardCards from '../../Components/Dashboard/DashboardCards';
import DashboardHeader from '../../Components/Dashboard/DashboardHeader';
 
import DonationLogo from '../../Assets/images/donation.svg';
import TodaysDonationLogo from '../../Assets/images/today-donation.svg';
import WeekReportLogo from '../../Assets/images/week-report.svg';
import { GlobalInfo } from '../../Contexts/GlobalContext';
import SampleRequests from './SampleRequests/SampleRequests';
import { SampleRequestService } from '../../Services/SampleRequest.Service';
import Toaster from '../../Components/Toaster';
import TokenService from '../../Services/Token.service';
import { Helmet } from 'react-helmet';
function AdminHome() {

    const { appUserIsLogin, theme, GetData, toggleSidebar ,isSidebarVisible} = useContext(GlobalInfo);   
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    const [openRequests, setOpenRequests] = useState();
    const [appointments, setAppointments] = useState();

    const [selectedRange, setSelectedRange] = useState('30 days');
    
    useEffect(()=>{  
        const userId = TokenService.getUserId();
        const params = { 
            flag: 1, 
            range: selectedRange,
            // user_id: userId,
            //  user_id: null,
        };
        
        SampleRequestService.getTotalWidgetCount(params)
        .then((response) => {
            if (response.success) {
                // setShowToast(true);
                // setToastMessage(response.message);
                // setToastVariant("success");
                if (response.count){ 
                    setOpenRequests(response.count.open_request);
                    setAppointments(response.count.appointment);
                }
            } else {
                setShowToast(true);
                setToastMessage(response.message);
                setToastVariant("danger");
            }
        })
        .catch((error) => {
       
            setShowToast(true);
            setToastMessage("Error getting Total Widget Count.");
            setToastVariant("danger");
            console.error("rror getting Total Widget Count.", error);
        });
    },[]);

    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
    const handleOpenRequestsClick = () => {
        setSelectedDateRange([null, null]);
        setSelectedStatuses([1]); // Set the filter to "Open"
    };



    const handleAppointmentsClick = () => { 
        const today = new Date();
        const formattedToday = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        setSelectedStatuses([]);
        setSelectedDateRange([formattedToday, formattedToday]); // Set start and end to today's date
    };
  return (
    <Fragment>
         <Helmet>
            <title>DonorX | Sample Requests</title>
        </Helmet>
        {/* collapsed-body */}
        {/* <div className={`el-middle ${!isSidebarVisible ? 'collapsed-body' : ''}`}> */}
                {/* <DashboardHeader/> */}
            <div className="el-middle-wrapper">
                <div className="el-middle-section"> 
                    <div className="el-middle-top">
                    <DashboardCards src={DonationLogo} label="Open Requests" count={openRequests}     onClick={handleOpenRequestsClick}/>
                    <DashboardCards src={TodaysDonationLogo} label="Today's Collections" count={appointments} onClick={handleAppointmentsClick}/>
                    {/* <DashboardCards src={WeekReportLogo} label="Report" count={8}/> */}
                  
                        {/* <div className="el-middle-top-col">
                            <div className="el-middle-top-img"><img src={DonationLogo} alt="Upcoming Donation"/></div>
                            <div className="el-middle-top-content">
                                <strong>10</strong>
                                <span>Upcoming Donation</span>
                            </div>
                        </div> 
                        <div className="el-middle-top-col">
                            <div className="el-middle-top-img"><img src={TodaysDonationLogo} alt="Today's Donation"/></div>
                            <div className="el-middle-top-content">
                                <strong>8</strong>
                                <span>Today's Donation</span>
                            </div>
                        </div>
                        <div className="el-middle-top-col">
                            <div className="el-middle-top-img"><img src={WeekReportLogo} alt="8 week"/></div>
                            <div className="el-middle-top-content">
                                <strong>8 week</strong>
                                <span>Report</span>
                            </div>
                        </div>*/}
                    </div>
              <SampleRequests selectedRange={selectedRange} setSelectedRange={setSelectedRange} openRequestsFilter={selectedStatuses} appointmentsFilter={selectedDateRange} setOpenRequestsFilter={setSelectedStatuses} setAppointmentsFilter={setSelectedDateRange} type="admin"></SampleRequests>
                </div>
            </div>
        {/* </div> */}
        <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
    </Fragment>
  );
}

export default AdminHome;
